import {
  pagination_styles_default
} from "./chunk.FGPWRBIU.js";
import {
  breakpointPixels
} from "./chunk.JI3RRLCG.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/pagination/pagination.ts
import { t as t2 } from "i18next";
var FadvPagination = class extends s {
  constructor() {
    super(...arguments);
    this.currentPage = 1;
    this.delta = 1;
    this.groupingThreshold = 5;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    this.handleResize = this.handleResize.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(document.body);
    this.handleResize();
  }
  disconnectedCallback() {
    this.resizeObserver.unobserve(document.body);
    super.disconnectedCallback();
  }
  handleResize() {
    this.isMobile = !!this.breakpoint && breakpointPixels[this.breakpoint] >= document.body.clientWidth;
  }
  gotoPage(page) {
    if (page < 1)
      return;
    if (page > this.totalPages)
      return;
    if (page === this.currentPage)
      return;
    this.currentPage = page;
  }
  gotoFirst() {
    this.gotoPage(1);
  }
  gotoLast() {
    this.gotoPage(this.totalPages);
  }
  gotoNext() {
    this.gotoPage(this.currentPage + 1);
  }
  gotoPrevious() {
    this.gotoPage(this.currentPage - 1);
  }
  handlePageChange() {
    emit(this, "fadv-page-change", { detail: { currentPage: this.currentPage, totalPages: this.totalPages } });
  }
  getPageLabel(page) {
    const isActive = this.currentPage === page;
    let label;
    if (isActive) {
      label = t2("components:pagination.currentPageLabel", { page });
    } else {
      label = t2("components:pagination.pageLabel", { page });
    }
    return label;
  }
  handleSelect(event) {
    this.gotoPage(parseInt(event.detail.item.value, 10));
  }
  renderMobilePage(page) {
    return $`<fadv-menu-item ?checked=${this.currentPage === page} value=${page}><fadv-visually-hidden>${this.getPageLabel(page)}</fadv-visually-hidden><span aria-hidden="true">${t2("components:pagination.page")} ${page}</span></fadv-menu-item>`;
  }
  renderMobilePages() {
    return $`<li class="pagination__dropdown"><fadv-dropdown block placement="bottom" ?hoist=${this.hoist}><fadv-button slot="trigger" variant="primary" outline pill>${t2("components:pagination.pageOf", { current: this.currentPage, total: this.totalPages })}</fadv-button><fadv-menu class="select__scroll-menu" scrollable @sl-select=${this.handleSelect}>${Array.from({ length: this.totalPages }).map((_, i) => this.renderMobilePage(i + 1))}</fadv-menu></fadv-dropdown></li>`;
  }
  renderPage(page) {
    return $`<li><fadv-button aria-label="${this.getPageLabel(page)}" role="button" variant="primary" outline circle ?active=${this.currentPage === page} @click=${() => this.gotoPage(page)} >${page}</fadv-button></li>`;
  }
  renderEllipsis() {
    return $`<li><fadv-icon class="pagination__ellipsis" aria-hidden="true" library="solid" name="ellipsis" foreground="primary"></fadv-icon></li>`;
  }
  renderPages() {
    if (this.isMobile)
      return [this.renderMobilePages()];
    if (this.totalPages <= this.groupingThreshold) {
      return Array.from({ length: this.totalPages }).map((_, index) => this.renderPage(index + 1));
    }
    const range = [1];
    for (let index = Math.max(2, this.currentPage - this.delta); index <= Math.min(this.totalPages - 1, this.currentPage + this.delta); index++) {
      range.push(index);
    }
    range.push(this.totalPages);
    return range.map((page, index, source) => {
      const previous = source[index - 1];
      if (previous && page - previous === 2 && page !== this.totalPages || previous && page - previous !== 1) {
        return $`${this.renderEllipsis()}${this.renderPage(page)}`;
      }
      return this.renderPage(page);
    });
  }
  render() {
    return $`<nav role="navigation" aria-label=${t2("components:pagination.navigation")} class=${o({
      pagination: true,
      "pagination--mobile": this.isMobile
    })} ><ul><li><fadv-button aria-label=${t2("components:pagination.firstPage")} role="button" variant="primary" circle outline ?disabled=${this.currentPage === 1} @click=${this.gotoFirst} ><fadv-icon aria-hidden="true" library="solid" name="angles-left"></fadv-icon></fadv-button></li><li><fadv-button aria-label=${t2("components:pagination.previousPage")} role="button" variant="primary" circle outline ?disabled=${this.currentPage === 1} @click=${this.gotoPrevious} ><fadv-icon aria-hidden="true" library="solid" name="angle-left"></fadv-icon></fadv-button></li>${this.renderPages()}<li><fadv-button aria-label=${t2("components:pagination.nextPage")} role="button" variant="primary" circle outline ?disabled=${this.currentPage === this.totalPages} @click=${this.gotoNext} ><fadv-icon aria-hidden="true" library="solid" name="angle-right"></fadv-icon></fadv-button></li><li><fadv-button aria-label=${t2("components:pagination.lastPage")} role="button" variant="primary" circle outline ?disabled=${this.currentPage === this.totalPages} @click=${this.gotoLast} ><fadv-icon aria-hidden="true" library="solid" name="angles-right"></fadv-icon></fadv-button></li></ul></nav>`;
  }
};
FadvPagination.styles = pagination_styles_default;
__decorateClass([
  e({ reflect: true, attribute: "current-page", type: Number })
], FadvPagination.prototype, "currentPage", 2);
__decorateClass([
  e({ reflect: true, attribute: "total-pages", type: Number })
], FadvPagination.prototype, "totalPages", 2);
__decorateClass([
  e({ reflect: true, type: Number })
], FadvPagination.prototype, "delta", 2);
__decorateClass([
  e({ reflect: true, type: Number })
], FadvPagination.prototype, "groupingThreshold", 2);
__decorateClass([
  e()
], FadvPagination.prototype, "breakpoint", 2);
__decorateClass([
  e({ type: Boolean })
], FadvPagination.prototype, "hoist", 2);
__decorateClass([
  t()
], FadvPagination.prototype, "isMobile", 2);
__decorateClass([
  watch("currentPage")
], FadvPagination.prototype, "handlePageChange", 1);
FadvPagination = __decorateClass([
  n("fadv-pagination")
], FadvPagination);

export {
  FadvPagination
};
